import { Button, Stack, Typography } from '@mui/material';
import { DocumentsContext } from 'Context/DocumentsContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DOCUMENTS_REDUCER_CASE } from 'Enum/documents';
import { useDictionary } from 'Hooks';
import { useContext, useMemo } from 'react';

export const ToggleFilter = () => {
  const { filter, setFilter, dispatchDocuments } = useContext(DocumentsContext);

  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  const toggleFilter = useMemo(
    () => [
      { text: dictionary.receivedDocuments, val: true },
      { text: dictionary.sentDocuments, val: false },
      { text: dictionary.allDocuments, val: null },
    ],
    [dictionary]
  );

  return (
    <Stack
      role='group'
      aria-label={`${dictionary.filterBy}-${dictionary.filterByType}`}
      direction='row'
      gap='24px'
      sx={{
        width: 'fit-content',
        m: '80px 0 20px 0',
      }}
    >
      {toggleFilter.map((filterItem, index: number) => {
        const isActive = filterItem.val === filter.isDocumentSentByUser;
        return (
          <Button
            key={index}
            aria-label={filterItem.text}
            aria-pressed={isActive}
            sx={{
              width: 'fit-content',
              p: '12px 20px',
              bgcolor: isActive ? '#1552E8' : '#FFF',
              borderRadius: '48px',
              border: '1px solid #E7EDFF',
              color: isActive ? '#FFF' : 'primary',
              ':hover': isActive
                ? {
                    bgcolor: '#1552E8',
                    cursor: 'auto',
                  }
                : {},
            }}
            onClick={() => {
              if (filterItem.val !== filter.isDocumentSentByUser) {
                const updatedFilter = {
                  ...filter,
                  isDocumentSentByUser: filterItem.val,
                };
                setFilter(updatedFilter);
                if (filter.advancedFilterActive) {
                  dispatchDocuments({
                    type: DOCUMENTS_REDUCER_CASE.FILTER,
                    payload: {
                      value: { filter: updatedFilter },
                    },
                  });
                }
              }
            }}
          >
            <Typography variant='body3'>{filterItem.text}</Typography>
          </Button>
        );
      })}
    </Stack>
  );
};
